export const convertToArray = (value) => {
  return Array.isArray(value) ? value : [value];
};

export const grouping = (groupBy, data = []) => {
  return Object.entries(
    data?.reduce((acc, item) => {
      if (!acc?.[item?.[groupBy]]) {
        acc[item?.[groupBy]] = [];
      }
      acc?.[item?.[groupBy]].push(item);
      return acc;
    }, {})
  ).map(([category, data]) => ({ category, data }));
};
